import { render, staticRenderFns } from "./rakentaja.vue?vue&type=template&id=3b2845ad&scoped=true&"
import script from "./rakentaja.vue?vue&type=script&lang=js&"
export * from "./rakentaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2845ad",
  null
  
)

export default component.exports